import DetailBox from './DetailBox';
export default {
  components: {
    DetailBox
  },
  props: {
    detailsLogo: String,
    detailsTitle: String,
    detailsSubtitle: {
      validator: () => true
    },
    detailsLink: String,
    title: String,
    subtitle: {
      validator: () => true
    },
    checked: Boolean,
    buttonShow: {
      type: Boolean,
      default: true
    },
    buttonText: String,
    buttonAction: Function,
    alignCenter: {
      type: Boolean,
      default: false
    }
  }
};